import React, { FC, PropsWithChildren, useEffect, useState } from "react";
import { Navigate } from "react-router";
import useAuthentication from "../../hooks/useAuthentication";
import AuthorizationContext, {
  AuthorizationContextValue,
} from "../../context/authorizationContext";
import { getAdditionalAccountInfo } from "../../api/webmaps";

const AuthorizationProvider: FC<PropsWithChildren> = ({ children }) => {
  const { user } = useAuthentication();
  const [context, setContext] = useState<AuthorizationContextValue>({
    shouldInitializeLoad: true,
    finishedLoading: false,
  });

  useEffect(() => {
    if (context.shouldInitializeLoad && user) {
      getAdditionalAccountInfo()
        .then((info) => {
          setContext((curr) => {
            return {
              ...curr,
              shouldInitializeLoad: false,
              finishedLoading: true,
              rolle: info.rolle,
              secLevel: info.sec_level,
            };
          });
        })
        .catch(() => {
          setContext((curr) => {
            return {
              ...curr,
              shouldInitializeLoad: false,
              finishedLoading: true,
            };
          });
        });
    }
  }, [context.shouldInitializeLoad, user]);

  if (user) {
    if (context.finishedLoading) {
      if (context.rolle === undefined) {
        // if we loaded additional user data but did not get a value for user role
        // we can safely assume the user is not authorized to use this webmap
        return <Navigate to={"/portal"} />;
      }
    }
  }

  return (
    <AuthorizationContext.Provider
      value={{
        ...context,
        setContextValue: setContext,
      }}
    >
      {children}
    </AuthorizationContext.Provider>
  );
};

export default AuthorizationProvider;
